


import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';

import { FormGroup, FormControl, Validators } from '@angular/forms';
import { finalize, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ClientDTO, ClientService, LookUpService, UserDTO, UserService } from 'synergy-core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.sass']
})
export class RegisterComponent implements OnInit {

  activeIndex: number = 0;
  items!: MenuItem[];
  personTypes!: any[];
  countries!: any[];
  states!: any[];
  cities!: any[];
  districts!: any[];
  economicActivities!: any[];
  nighboorhoods!: any[];

  isPhysicalPerson: boolean = false;
  organizationForm!: FormGroup
  organizationSubmitted: boolean = false;

  userAccountForm!: FormGroup
  userAccountSubmitted: boolean = false;

  confirmationForm!: FormGroup
  confirmationSubmittted: boolean = false;
  passwordIsValid = false;
  passwordMatch = false;
  loading = false;

  constructor(private sharedService: LookUpService,
    private organizationService: ClientService,
    private userAccountService: UserService,
    private router: Router) { }

  ngOnInit() {
    this.getPersonTypes();
    this.getTabItems();
    this.getCountries();
    this.getEconomicActivities(1);
    this.setOrganizationForm();
  }

  setOrganizationForm() {
    this.organizationForm = new FormGroup({
      economicActivityId: new FormControl(null, [Validators.required]),
      personTypeId: new FormControl(null, [Validators.required]),
      identification: new FormControl(null, [Validators.required]),
      name: new FormControl(null, [Validators.required]),
      lastName: new FormControl(null),
      comercialName: new FormControl(),
      emailAddress: new FormControl(null, [Validators.required, Validators.email]),
      phoneNumber1: new FormControl("(506)", [Validators.required]),
      phoneNumber2: new FormControl(),
      countryId: new FormControl(null, [Validators.required]),
      stateId: new FormControl(null, [Validators.required]),
      cityId: new FormControl(null, [Validators.required]),
      districtId: new FormControl(null, [Validators.required]),
      neighborhoodId: new FormControl(null),
      address: new FormControl(null, [Validators.required, Validators.maxLength(500)]),
    });
  }

  setUserAccountForm() {
    this.userAccountForm = new FormGroup({
      identification: new FormControl(this.organizationForm.value.identification, [Validators.required]),
      name: new FormControl(this.organizationForm.value.name, [Validators.required]),
      branchId: new FormControl(null),
      loginName: new FormControl(null, [Validators.required]),
      lastName: new FormControl(this.organizationForm.value.lastName, [Validators.required]),
      fullName: new FormControl(null),
      password: new FormControl(null, [Validators.required]),
      passwordConfirm: new FormControl(null, [Validators.required]),
      temporalPassword: new FormControl(null),
      emailAddress: new FormControl(this.organizationForm.value.emailAddress, [Validators.required, Validators.email]),
      phoneNumber: new FormControl(this.organizationForm.value.phoneNumber1, [Validators.required]),
      personTypeId: new FormControl(this.organizationForm.value.personTypeId, [Validators.required]),
      expirationDate: new FormControl(new Date()),
      imageURL: new FormControl(null),

    });
  }

  setConfirmationForm() {
    this.confirmationForm = new FormGroup({
      agreeTerms: new FormControl(false, [Validators.pattern('true')])
    });
  }
  get organizationControls() { return this.organizationForm.controls; }
  get userAccountControls() { return this.userAccountForm.controls; }
  get confirmationControls() { return this.confirmationForm.controls; }

  getPersonTypes() {
    this.sharedService.getPersonTypes().subscribe(data => {
      if (data) {
        this.personTypes = data;
      }
    });
  }

  getTabItems() {
    this.items = [{
      label: 'Organizacion',
      command: (event: any) => {
        this.activeIndex = 0;
      }
    },
    {
      label: 'Cuenta de Usuario',
      command: (event: any) => {
        this.activeIndex = 1;
      }
    },
    {
      label: 'Confirmacion',
      command: (event: any) => {
        this.activeIndex = 3;
      }
    }];
  }

  getCountries() {
    this.sharedService.GetCountries().subscribe(val => {
      this.countries = val.Data;
    });
  }

  getEconomicActivities(countryId: number) {
    this.sharedService.GetEconomicActivities(countryId).subscribe(val => {
      this.economicActivities = val.Data;
    });
  }

  onSelectCountry() {
    this.sharedService.GetStatesByCountryId(this.organizationForm.value.countryId).subscribe(data => {
      if (data) {
        this.states = data.Data;
      }
    });
  }

  onSelectState() {
    this.sharedService.GetCityByStateId(this.organizationForm.value.stateId).subscribe(data => {
      if (data) {
        this.cities = data.Data;
      }
    });
  }

  onSelectCity() {
    this.sharedService.GetDistrictByCityId(this.organizationForm.value.cityId).subscribe(data => {
      if (data) {
        this.districts = data.Data;
      }
    });
  }

  onSelectDistrict(value: any) {
    this.sharedService.GetNeighborhoodByDistrictId(this.organizationForm.value.districtId).subscribe(data => {
      if (data) {
        this.nighboorhoods = data.Data;
      }
    });
  }

  onSubmitOrganization() {
    this.organizationSubmitted = true;
    if (this.organizationForm.invalid) {
      return;
    }

    this.setUserAccountForm();
    this.activeIndex++;
  }

  onSubmitAccount() {
    this.userAccountSubmitted = true;
    /*if (this.userAccountForm.invalid) {
      return;
    }

    if (!this.passwordIsValid) {
      return;
    }



    if (this.userAccountForm.value.password == this.userAccountForm.value.passwordConfirm) {
      this.passwordMatch = true;
    } else {
      this.passwordMatch = true;
      return;
    }*/


    this.setConfirmationForm();
    this.activeIndex++;
  }

  onSubmitConfirmation() {
    this.confirmationSubmittted = true;
    if (this.confirmationForm.invalid) {
      return;
    }

    this.loading = true;
    let organizationDto = new ClientDTO();
    organizationDto.Id = '00000000-0000-0000-0000-000000000000';
    organizationDto.ClientId = '00000000-0000-0000-0000-000000000000';
    organizationDto.ApplicationId = environment.applicayionId;
    organizationDto.PersonTypeId = this.organizationForm.value.personTypeId;
    organizationDto.Identification = this.organizationForm.value.identification;
    organizationDto.Name = this.organizationForm.value.name;
    organizationDto.ComercialName = this.organizationForm.value.comercialName;
    organizationDto.LastName = this.organizationForm.value.lastName; //TODO
    organizationDto.CityId = this.organizationForm.value.cityId;
    organizationDto.StateId = this.organizationForm.value.stateId;
    organizationDto.DistrictId = this.organizationForm.value.districtId;
    organizationDto.StateId = this.organizationForm.value.stateId;
    organizationDto.CountryId = this.organizationForm.value.countryId;
    organizationDto.NeighborhoodId = this.organizationForm.value.neighborhoodId;
    organizationDto.Address = this.organizationForm.value.address;
    organizationDto.Detail = this.organizationForm.value.detail;
    organizationDto.PhoneNumber1 = this.organizationForm.value.phoneNumber1;
    organizationDto.EmailAddress = this.organizationForm.value.emailAddress;
    organizationDto.IsActive = true;
    organizationDto.EconomicActivityId = this.organizationForm.value.economicActivityId;
    organizationDto.CreatedBy = '00000000-0000-0000-0000-000000000000';
    organizationDto.CreatedDate = new Date();

    this.organizationService.Create(organizationDto).pipe(
      finalize(() => {
        this.confirmationSubmittted = false;
        this.organizationSubmitted = false;
        this.userAccountSubmitted = false;
        this.loading = false;
      }),
      catchError((error) => {
        throw error;
      })
    ).subscribe((data) => {
      if (data && data.Success) {
        let userAccountDto = new UserDTO();
        userAccountDto.Id = 'DF8A321C-DDDE-4F89-9506-CF088C3D6E01';
        userAccountDto.ClientId = data.Data[0].Id;
        userAccountDto.ApplicationId = environment.applicayionId;
        userAccountDto.Name = this.userAccountForm.value.name;
        userAccountDto.Detail = this.userAccountForm.value.detail;
        userAccountDto.EmailAddress = this.userAccountForm.value.emailAddress;
        userAccountDto.LoginName = this.userAccountForm.value.loginName;
        userAccountDto.Password = this.userAccountForm.value.password;
        userAccountDto.IsActive = true;
        userAccountDto.CreatedBy = '00000000-0000-0000-0000-000000000000';
        userAccountDto.CreatedDate = new Date();
        this.userAccountService.Create(userAccountDto).subscribe((data) => {
          if (data.Success) {
            this.organizationForm.reset();
            this.userAccountForm.reset();
            this.confirmationForm.reset();
            this.router.navigate(['/Welcome']);
          }
        });
      }
    });
  }

  onPersonTypeChange(personTypeId: any) {
    this.isPhysicalPerson = false;
    if (personTypeId == 1) {
      this.isPhysicalPerson = true;
    }
  }

  onPasswordValid(event: any) {
    this.passwordIsValid = event;
  }

  onPrevious() {
    this.activeIndex--;
  }

  onCancel() {
    this.router.navigate(['/Login']);
  }

  saveData() {
  }
}
